import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ApiResourceLocation, Dictionary } from '@softline/core';
import {
  SOFTLINE_API_GARAGE_ORDER_ITEM,
  SOFTLINE_API_GARAGE_ORDER_ITEM_DEFAULT,
  SOFTLINE_API_GARAGE_ORDER_ITEM_DELETE,
  SOFTLINE_API_GARAGE_ORDER_ITEM_UPDATE,
  SOFTLINE_API_GARAGE_ORDER_ITEMS,
} from '../garage.api';
import { OrderItem } from '../models/order-item';

@Injectable()
export class GarageOrderItemRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  private createLocation(
    path: string,
    pathParams?: Dictionary<unknown>
  ): ApiResourceLocation {
    return pathParams ? { path, pathParams } : { path };
  }

  retrieve(id: number): Promise<OrderItem[]> {
    return this.#dataAccess.get(
      this.createLocation(SOFTLINE_API_GARAGE_ORDER_ITEMS, { id })
    );
  }

  retrieveTemplate(orderItem: Partial<OrderItem>): Promise<OrderItem> {
    return this.#dataAccess.create(
      this.createLocation(SOFTLINE_API_GARAGE_ORDER_ITEM_DEFAULT),
      orderItem
    );
  }

  create(payload: Partial<OrderItem[]>): Promise<OrderItem[]> {
    return this.#dataAccess.create(
      this.createLocation(SOFTLINE_API_GARAGE_ORDER_ITEM),
      payload
    );
  }
  update(id: number, payload: Partial<OrderItem>): Promise<OrderItem> {
    return this.#dataAccess.update(
      this.createLocation(SOFTLINE_API_GARAGE_ORDER_ITEM_UPDATE, { id }),
      payload
    );
  }
  delete(id: number): Promise<OrderItem> {
    return this.#dataAccess.delete(
      this.createLocation(SOFTLINE_API_GARAGE_ORDER_ITEM_DELETE, { id })
    );
  }
}
